import useReduxValue from "./useReduxValue";
import useReduxTable from "./useReduxTable";

const useReportReduxTable = (
    rowsSelector,
    fetchRowsAction,
    columnsSelector,
    fetchColumnsAction,
    selectedIdsSelector,
    setSelectedIdsAction,
    searchStringSelector,
    setSearchStringAction,
    pageNumberSelector,
    setPageNumberAction,
    limitNumberSelector,
    setLimitNumberAction,
    sortDataSelector,
    setSortDataAction,
    filterDataSelector,
    setFilterDataAction,
    errorSelector,
    setErrorAction,
    totalSelector,
    busySelector,
    reportLevelSelector,
    setReportLevelAction,
    reportTypeSelector,
    setReportTypeAction,
    openSelector = null, 
    setOpenAction = null
) => {
    const {
        rows, columns,
        total, busy,
        selectedIds, setSelectedIds,
        searchString, setSearchString,
        pageNumber, setPageNumber,
        limitNumber, setLimitNumber,
        filterData, setFilterData,
        sortData, setSortData,
        error, setError
    } = useReduxTable(
        rowsSelector, fetchRowsAction,
        columnsSelector, fetchColumnsAction,
        selectedIdsSelector, setSelectedIdsAction,
        searchStringSelector, setSearchStringAction,
        pageNumberSelector, setPageNumberAction,
        limitNumberSelector, setLimitNumberAction,
        sortDataSelector, setSortDataAction,
        filterDataSelector, setFilterDataAction,
        errorSelector, setErrorAction,
        totalSelector,
        busySelector,
    );
    
    const [open, setOpen] = useReduxValue(openSelector ?? (() => false), setOpenAction ?? (() => {}));
    const [reportLevel, setReportLevel] = useReduxValue(reportLevelSelector, setReportLevelAction);
    const [reportType, setReportType] = useReduxValue(reportTypeSelector, setReportTypeAction);

    return {
        rows, columns,
        total, busy,
        selectedIds, setSelectedIds,
        searchString, setSearchString,
        pageNumber, setPageNumber,
        limitNumber, setLimitNumber,
        sortData, setSortData,
        filterData, setFilterData,
        error, setError,
        reportLevel, setReportLevel,
        reportType, setReportType,
        open, setOpen
    }
};

export default useReportReduxTable;
